import { Component, OnInit } from '@angular/core';
import { AuthService } from '@features/auth/services/auth.service';
import { User } from '@features/user/interfaces/user.interface';
import { UserService } from '@features/user/services/user.service';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCog, faXmark } from '@fortawesome/free-solid-svg-icons';
import { APIWebService } from '@shared/services/api-web.service';
import { LayoutService } from './services/layout.service';

@Component({
  selector: 'fc-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {
  faCog = faCog;
  isShowFooter = false;
  faXmark = faXmark;
  faWhatsapp = faWhatsapp;
  user?: User;
  chat: any;
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private layoutService: LayoutService,
    private apiWebService: APIWebService
  ) {}

  ngOnInit(): void {
    this.userService.currentUserValue.subscribe((user) => {
      this.user = user;
    });
    this.layoutService.isShowFooter$.subscribe((isShowFooter) => {
      this.isShowFooter = isShowFooter;
    });
    this.apiWebService.getLocalJsonChat().subscribe((data: any) => {
      this.chat = data;
    });
  }
  logout() {
    this.authService.logout();
  }
}
